import Diaporama from './Diaporama.js'
export default Diaporama;
